/* eslint-disable no-underscore-dangle */
import { navigate } from 'gatsby';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

import fields from './config';
import { handleLogin, synchronizeStoreData } from '../../../services/auth';
import useFirebase from '../../../services/firebase/useFirebase';
import InputBloc from '../InputBloc';
import { fetchJSON, withTimeout } from '../../../utils/network';

function FormLogin() {
    const [formError, setFormError] = useState(null);
    const [storesList, setStoresList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            try {
                const stores = await fetchJSON(
                    'https://raw.githubusercontent.com/JimmyBeldone/brico-shared/main/listWithLabel.json',
                );
                setStoresList(stores || []);
            } catch (error) {
                console.error('Error fetching stores list:', error);
                setFormError(
                    'Une erreur est survenue lors de la récupération de la liste des magasins',
                );
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, []);

    const { id } = fields;

    const firebase = useFirebase();
    const {
        formState: { errors },
        handleSubmit,
        register,
    } = useForm();

    const onSubmit = async (data) => {
        setIsLoading(true);
        setFormError(null);

        if (!firebase) {
            setFormError("Erreur d'initialisation Firebase");
            setIsLoading(false);
            return;
        }

        if (storesList.length === 0) {
            setFormError(
                'Une erreur est survenue sur le serveur, veuillez réessayer',
            );
            setIsLoading(false);
            return;
        }

        const storeId = data.id;

        const storeExistsLegacy = storesList.find(
            (store) => store.legacy === parseInt(storeId, 10),
        );
        const storeExistsEasier = storesList.find(
            (store) => store.easier === parseInt(storeId, 10),
        );

        const storeExists = storeExistsLegacy || storeExistsEasier;

        const email = 'store.brico@brico.com';
        const password = '$t0r3.Br!c0';

        if (storeExists) {
            try {
                // Authentification Firebase
                const resp = await withTimeout(
                    firebase.auth().signInWithEmailAndPassword(email, password),
                );

                // Enregistrer les informations d'authentification
                await handleLogin(
                    resp.user,
                    storeExists.id,
                    storeExists.label,
                    storeExists,
                );

                // Synchroniser les données du magasin avec Firebase
                synchronizeStoreData(firebase, storeExists.id, storeExists);

                // Redirection après authentification réussie
                navigate('/?logged');
            } catch (error) {
                console.error('Login error:', error);
                setFormError(
                    'Une erreur est survenue sur le serveur, veuillez réessayer plus tard',
                );
                setIsLoading(false);
            }
        } else {
            setFormError(
                'Votre identifiant est incorrecte, utilisez le code "legacy"',
            );
            setIsLoading(false);
        }
    };

    return (
        <form
            name='FormLogin'
            onSubmit={handleSubmit(onSubmit)}
            style={{ margin: '10% auto', maxWidth: '500px' }}
        >
            {[id].map((item) => (
                <InputBloc
                    key={`form-${item.name}-field-${item.name}`}
                    {...item}
                    register={register}
                    errors={errors}
                />
            ))}
            <div
                style={{
                    color: '#E63228',
                    fontSize: '20px',
                    margin: '15px auto',
                    textAlign: 'center',
                }}
            >
                {formError && formError}
            </div>
            {isLoading ? (
                <div style={{ textAlign: 'center' }}>
                    Authentification en cours...
                </div>
            ) : (
                <input type='submit' className='button-text' value='Valider' />
            )}
        </form>
    );
}

FormLogin.propTypes = {};

export default FormLogin;
